import React, { useMemo } from "react";
import { EChartsOption } from "echarts";
import ReactEchart from "../../../../../../molecules/ReactEchart";

const SmoothLineChart = React.memo((props: any) => {
  const { data } = props;

  const options = useMemo<EChartsOption>(
    () => ({
      xAxis: {
        type: "category",
        data: data?.length > 0 ? data?.map((item) => item.month) : [],
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { fontSize: 12, color: "#666" },
        splitLine: {
          show: true,
          lineStyle: {
            type: "dashed",
            color: "#E5E5E5",
          },
        },
      },
      // dataZoom: [
      //   {
      //     type: "inside",
      //     start: 0,
      //     end: 20,
      //   },
      //   {
      //     start: 0,
      //     end: 20,
      //   },
      // ],
      yAxis: {
        type: "value",
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { show: false },
        axisLabel: { show: false },
      },
      series: [
        {
          data: data?.length > 0 ? data?.map((item) => item.count) : [],
          type: "line",
          smooth: true,
          showSymbol: true,
          symbol: "circle",
          symbolSize: 8,
          itemStyle: {
            color: "#3E7A9E",
            borderColor: "#fff",
            borderWidth: 2,
          },
          lineStyle: {
            width: 3,
            color: "#3E7A9E",
          },
          areaStyle: {
            color: "rgba(62, 122, 158, 0.15)",
          },
          emphasis: {
            itemStyle: {
              color: "#3E7A9E",
              borderColor: "#fff",
              borderWidth: 2,
            },
          },
        },
      ],
      tooltip: {
        // trigger: "axis",
        backgroundColor: "#3E7A9E",
        borderColor: "transparent",
        textStyle: { color: "#fff", fontSize: 14, fontWeight: "bold" },
        axisPointer: {
          type: "line",
          lineStyle: {
            type: "dashed",
            color: "#3E7A9E",
          },
        },
        // extraCssText: "width: 200px; white-space: normal;", // 👈 increase width & allow wrapping
      },
      grid: {
        left: "3%",
        right: "3%",
        top: "5%",
        bottom: "5%",
        containLabel: true,
      },
    }),
    [data]
  );

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "700px",
        height: "477px",
        margin: "auto",
        display: "flex",
        alignItems: "end",
      }}
    >
      <ReactEchart options={options} style={{ width: "100%", height: "100%" }} />
    </div>
  );
});

export default SmoothLineChart;
